/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SetPinnedRequestBody = {
  /**
   * The ID of the chat to pin or unpin
   */
  id: string;
  /**
   * True to pin the chat, false to unpin it
   */
  pinned: boolean;
};

/** @internal */
export type SetPinnedRequestBody$Outbound = {
  id: string;
  pinned: boolean;
};

/** @internal */
export const SetPinnedRequestBody$outboundSchema: z.ZodMiniType<
  SetPinnedRequestBody$Outbound,
  SetPinnedRequestBody
> = z.object({
  id: z.string(),
  pinned: z.boolean(),
});

export function setPinnedRequestBodyToJSON(
  setPinnedRequestBody: SetPinnedRequestBody,
): string {
  return JSON.stringify(
    SetPinnedRequestBody$outboundSchema.parse(setPinnedRequestBody),
  );
}
